export default __webpack_public_path__ + "static/media/018-army airplane.87f46faa.svg";